import { Link } from '@tanstack/react-router';
import { Database, Home } from 'lucide-react';

interface NotFoundPageProps {
  message?: string;
}

export function NotFoundPage({ message }: NotFoundPageProps) {
  return (
    <div className="mx-auto max-w-2xl">
      <div className="border-theme bg-theme-elevated/50 rounded-xl border p-12 text-center backdrop-blur-sm">
        <Database className="mx-auto mb-4 size-12 text-text-subtle" />
        <h3 className="text-theme-primary mb-2 text-lg font-semibold">Not Found</h3>
        <p className="text-theme-muted mb-6">
          {message || "The page you're looking for doesn't exist or couldn't be loaded."}
        </p>
        <div className="flex justify-center gap-3">
          <Link
            to="/simulations"
            className="
              inline-flex items-center gap-2 rounded-lg bg-action-primary px-4 py-2 font-medium text-white
              transition-colors
              hover:bg-action-primary-hover
            "
          >
            <Database className="size-4" />
            Simulations
          </Link>
          <Link
            to="/"
            className="
              border-theme
              hover:bg-theme-elevated
              text-theme-secondary inline-flex items-center gap-2 rounded-lg border px-4 py-2 font-medium
              transition-colors
            "
          >
            <Home className="size-4" />
            Home
          </Link>
        </div>
      </div>
    </div>
  );
}
